export default {
    current_choice: 'Mevcut seçim',
    book_now: 'Şimdi rezervasyon yap',
    minimum_age: 'Sadece {age}+ yaş için',
    excess_liability: 'Ekstra sorumluluk',
    security_deposit: 'Güvenlik depozitosu',
    fuel_policy: 'Yakıt politikası',
    like_for_like: 'Aynı ile değişim',
    full_to_full: 'Dolu dolu',
    miles_per_rental: 'Kiralama başına {mileage} ücretsiz mil',
    km_per_rental: 'Kiralama başına {mileage} ücretsiz km',
    unlimited_mileage: 'Sınırsız mil',
    unlimited_mileage_km: 'Sınırsız km',
    non_amendable: 'Değiştirilemez',
    non_refundable: 'İade edilemez',
    free_cancellation_until: 'Şu zamana kadar ücretsiz iptal',
    basic_free_cancellation: 'Başlangıç saatinden 48 saat öncesine kadar ücretsiz iptal',
    cancellation_in_line_with: 'İptal şu kurallara göre',
    tcs: 'Şartlar &amp; Koşullar',
    free_extras_on_collection: 'Teslimatta iki ücretsiz ek',
    glass_and_tyres_covered: 'Cam ve lastikler dahil',
    number_of_passengers: 'Yolcu sayısı',
    number_of_bags: 'Bagaj sayısı',
    fuel_type: 'Yakıt türü',
    co2: 'CO2',
    aircon: 'Klima',
    transmission: 'Vites',
    book_type: '{type} rezervasyon yap',
    debit_card_deposit: 'Depozito için banka kartı kabul edilir',
    fast_track_included: 'Hızlı geçiş dahil',
    view_all: 'Tümünü görüntüle',
};
